// JavaScript source code
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import dataJoinUs from '../assets/fake-data/data-joinus';
import Header from '../components/header';
import SubFooter from '../components/subfooter';
import Button from '../components/button';
import { getUser } from '../request';
import LoginDialog from '../components/loginDialog';

function JoinUs(props) {    
    let activeIndex = 3;
    const theData = dataJoinUs;
    const [screenSize, setScreenSize] = useState(window.innerWidth);
    const [isShowLogin, setIsShowLogin] = useState(false);
    var user = getUser();
    const finishLogin = () => {
        setIsShowLogin(false);
        //navigate("/JoinUsStep");
        user = getUser();
    }
    useEffect(() => {
        const handleResize = () => {
            setScreenSize(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const navigate = useNavigate();
   
    return (      
        <div className={`aboutUs joinUs`} >
            <Header activeIndex={activeIndex} user={user} setIsShowLogin={setIsShowLogin}/>
            <div className="content js_content">
                <div className="pageHead">
                    <div className="pageTitle">{theData.pageTitle}</div>
                    <div className="pageSubTitle">{theData.pageSubTitle}</div>
                    <div className="pageDetail mshow">{theData.pageDetail}</div>
                </div>
                <Button btnclass="join_btn " path='/JoinUsStep' title="申请入驻"/>
                <div className="subcontent">
                    <div className="title">{theData.title}</div>
                    {
                        screenSize > 991 ? (
                            <div className="hezuo">                            {
                                theData.content.map((item, index) => (
                                    <div key={`item${index}`} className="hz_item">
                                        <img  src={item.img} />
                                        <div className="subtitle">{item.subtitle}</div>
                                    </div>
                            ))
                            }
                            </div>) :
                            (
                             <div className="m_hezuo">                                  
                                    {
                                        theData.content && theData.content.length > 1 && (
                                            <div className="m_hezuo1">
                                            <Swiper
                                                modules={[Navigation]}
                                                spaceBetween={0}
                                                slidesPerView={1}
                                                autoplay={{ delay: 5000, disableOnInteraction: false }}
                                                pagination={{ el: '.swiper-pagination', clickable: true }}
                                                speed={1000}

                                                loop={true}
                                                navigation
                                            >
                                                {
                                                    theData.content.map((item, index) => (
                                                        <SwiperSlide key={`item1${index}`}>
                                                            <div className="slider-about">
                                                                <div className="overlay">
                                                                    <img src={item.img} />
                                                                    <div className="subtitle">{item.subtitle}</div>

                                                                </div>
                                                            </div>
                                                        </SwiperSlide>
                                                    ))
                                                }
                                            </Swiper>
                                            <div className="swiper-pagination" slot="pagination"></div>
                                            </div>
                                        )

                                    }
                            </div>
                    )
                    }
                    <div className="geduan"></div>
                    <div className="title">{theData.title1}</div>                    
                    <div className="hezuo">                            {
                        theData.content1.map((item, index) => (
                            <div key={`item2${index}`}  className="hz_item hz_item1">
                                <img src={item.img} />
                                <div className="subtitle ">{item.subtitle}</div>
                            </div>
                        ))
                    }
                    </div>                   

                </div>
                <Button btnclass="join_btn1 " path='/JoinUsStep' title="申请入驻" />

            </div>
            <SubFooter />
            <LoginDialog isShowLogin={isShowLogin} onCancel={finishLogin} />

        </div>
          
    );
}

export default JoinUs;